import { IntegrationLookup } from '../../models/integration-lookup.model';
import { Action, createReducer, on } from '@ngrx/store';
import { IntegrationMappingsActions } from './integration-mappings.actions';
import { DataResult } from '@progress/kendo-data-query';

export interface IntegrationMappingsState {
    integrationMappingsList: DataResult;
    integrationMappingsLookup: IntegrationLookup;
    isLoading: boolean;
    isSaving: boolean;
    status: { value: HttpResponseStatus };
}

export interface IntegrationMappingResponse {
    status: HttpResponseStatus;
    message: string;
}

export enum HttpResponseStatus {
    Success,
    Failed,
    None
}

export const integrationMappingsInitialState: IntegrationMappingsState = {
    integrationMappingsList: {
        data: [],
        total: 0
    },
    integrationMappingsLookup: {
        clientIntegrationType: {}
    },
    isLoading: false,
    isSaving: false,
    status: { value: HttpResponseStatus.None }
};

export const integrationMappingsReducer = (
    reducerState: IntegrationMappingsState,
    reducerAction: Action
): IntegrationMappingsState => {
    return createReducer(
        integrationMappingsInitialState,
        on(
            IntegrationMappingsActions.getAllIntegrationMappings,
            (state): IntegrationMappingsState => ({
                ...state,
                isLoading: true
            })
        ),
        on(
            IntegrationMappingsActions.setAllIntegrationMappings,
            (state, action): IntegrationMappingsState => ({
                ...state,
                integrationMappingsList: action.integrationMappingsList,
                isLoading: false
            })
        ),
        on(
            IntegrationMappingsActions.getIntegrationMappingsLookup,
            (state): IntegrationMappingsState => ({
                ...state,
                isLoading: true
            })
        ),
        on(
            IntegrationMappingsActions.setIntegrationMappingsLookup,
            (state, action): IntegrationMappingsState => ({
                ...state,
                integrationMappingsLookup: action.integrationMappingsLookup,
                integrationMappingsList: action.integrationMappingsList,
                isLoading: false
            })
        ),
        on(
            IntegrationMappingsActions.setIsSaving,
            (state, action): IntegrationMappingsState => ({
                ...state,
                isSaving: action.isSaving
            })
        ),
        on(
            IntegrationMappingsActions.setStatus,
            (state, action): IntegrationMappingsState => ({
                ...state,
                status: { value: action.status }
            })
        )
    )(reducerState, reducerAction);
};
